import { render } from "./Accessibility.vue?vue&type=template&id=6d34e586&scoped=true&ts=true"
import script from "./Accessibility.vue?vue&type=script&lang=ts"
export * from "./Accessibility.vue?vue&type=script&lang=ts"

import "./Accessibility.vue?vue&type=style&index=0&id=6d34e586&scoped=true&lang=css"

import exportComponent from "G:\\01.Progetti\\GitHub\\SCIENZE_NATURALI_app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d34e586"]])

export default __exports__